import { FC, useEffect, useState } from "react";
import { useSelector } from 'react-redux';

import styles from "../headerBtn.module.scss";

interface IOptions {
  setDisabledButton: (state: boolean) => void;
  setState: (state: string) => void;
  id?: string;
};

const EditDesktopOnCharts: FC<IOptions> = ({ setDisabledButton, setState, id }) => {
  const { desktopList } = useSelector((state: any) => state.charts?.chartsList);

  const [error, setError] = useState<string>('');

  const index = id ? desktopList.findIndex((el: any) => el.id.toString() === id) : 0;
  const findItem = desktopList[index];

  const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.trim();
    
    if (value === '') {
        setError('Вы ввели пустое значение.');
        setDisabledButton(true);
        setState('');
        return;
    }

    const sameNameItem = desktopList.find((el: any) => el.name === value);
    if (sameNameItem && sameNameItem.id.toString() !== id) {
        setError('Уже есть рабочий стол с таким названием.');
        setDisabledButton(true);
    } else {
        setError('');
        setState(value);
        setDisabledButton(false);
    }
  };

  useEffect(()=>{
    setState(findItem.name);
  }, [setState, findItem]);

  return (
    <div className={styles.block__info}>
      <div className={styles.limit__block}>
        <span>Наименование:</span>
        <div className={styles.error__input_block}>
          <input
            type="text"
            defaultValue={findItem.name || ''}
            className={error ? styles.error__input : styles.limit__input}
            onChange={handleChangeInput}
          />
          {error && <span className={styles.error}>{error}</span>}
        </div>
      </div>
    </div>
  );
};

export default EditDesktopOnCharts;
